/**
 * Workspace-relative doc pointers used by Admin Guides.
 *
 * @remarks
 * This keeps guide modules DRY and makes it easy to confirm we started in `docs/` (docs-first requirement).
 * Do not add secrets or credential-like URLs here.
 */
export const GUIDE_SOURCE_DOCS = {
  ACCOUNTING_STANDARDS: "docs/guides/ACCOUNTING_STANDARDS.md",
  ADMIN_API_DOCS: "docs/admin/readmes/API_DOCUMENTATION.md",
  ADMIN_OVERVIEW: "docs/admin/README.md",
  ADMIN_REQUIREMENTS: "docs/admin/requirements/current-requirements.md",
  ADMIN_TESTING: "docs/admin/testing/README.md",
  BULK_EMAIL: "docs/admin/readmes/BULK_EMAIL.md",
  ADMIN_BUG_TRACKER: "docs/admin/readmes/BUG_TRACKER.md",
  CRM_MIGRATION_AND_CUTOVER: "docs/features/crm/migration-and-cutover.md",
  CRM_OWNERSHIP_MODEL: "docs/features/crm/ownership-model.md",
  CRM_RELATIONSHIP_EXPLAINER: "docs/admin/readmes/CRM_AND_SUPPORT.md",
  ADMIN_SUBSCRIPTION_MGMT:
    "docs/backend/src/HelloCashflowDomain/Documentation/AdminSite/ADMIN_SUBSCRIPTION_MANAGEMENT.md",
  BUG_TRACKER_FEATURE: "docs/features/BUG_TRACKER.md",
  CSV_EXPORT_FEATURE: "docs/admin/readmes/CSV_EXPORT_FEATURE_IMPLEMENTATION.md",
  DEMO_COMPANY: "docs/features/DEMO_COMPANY_README.md",
  // Legacy "product onboarding" docs were consolidated into the canonical onboarding guide.
  // Keep this key to avoid churn in existing admin guides.
  FRONTEND_PRODUCT_ONBOARDING: "docs/features/ONBOARDING.md",
  ONBOARDING_APP: "docs/features/ONBOARDING.md",
  PARTNER_DASHBOARD: "docs/features/PARTNER_DASHBOARD.md",
  PARTNER_PORTAL_RUNBOOK:
    "docs/runbooks/PARTNER_PORTAL_PRODUCTION_ASSURANCE.md",
  AGENT_BROWSER: "docs/runbooks/AGENT_BROWSER.md",
  POSTPAYMENT_UAT: "docs/app/docs/PostPaymentSetup_UAT_Checklist.md",
  STRIPE_SUBSCRIPTIONS: "docs/features/STRIPE_SUBSCRIPTIONS.md",
  USAGE_TRACKING: "docs/features/USAGE_TRACKING.md",
  LOGGING: "docs/LOGGING.md",
  LIVE_ALERT_FEED: "docs/admin/readmes/LIVE_ALERT_FEED.md",
  LIVE_ALERT_RULES: "docs/admin/readmes/LIVE_ALERT_RULES.md",
  PARTNER_STATS: "docs/admin/readmes/PARTNER_STATS.md",
  PLAIN_LANGUAGE: "docs/guides/PLAIN_LANGUAGE.md",
  ACCOUNTANT_REENGAGEMENT_PLAN:
    "docs/plans/archive/accountant-quick-wins-20260525-1427/accountant-reengagement-20260525-1427-accountant-quick-wins.md",
  ACCOUNTANT_REENGAGEMENT_SPRINT_3_SOURCE_LEDGER:
    "docs/plans/archive/accountant-quick-wins-20260525-1427/sprint-3-evidence/source-ledger-20260525.md",
  ACCOUNTANT_REENGAGEMENT_SPRINT_3_CONTENT_PACK:
    "docs/plans/archive/accountant-quick-wins-20260525-1427/sprint-3-evidence/accountant-reengagement-support-content-pack-20260525.md",
} as const;
